const Guidelines = () => {
  const guidelines = [
    "Titles must not have significant phonetic similarities to existing titles.",
    "Titles must not include common disallowed prefixes or suffixes (e.g., 'The', 'India', 'News', 'Samachar').",
    "Titles must not closely resemble existing titles due to variations in spelling (e.g., 'Namaskar' vs. 'Namascar').",
    "Titles must not contain disallowed words (e.g., 'Police', 'Crime', 'Corruption', 'CBI', 'CID', 'Army').",
    "Titles must not combine existing titles into a new title (e.g., combining 'Hindu' and 'Indian Express' into 'Hindu Indian Express').",
    "Titles with similar meanings in different languages are not allowed (e.g., 'Daily Evening' and 'Pratidin Sandhya').",
    "Titles must not add periodicity (e.g., 'daily', 'weekly', 'monthly') to existing titles to form new ones.",
    "Titles must not merge multiple words into a single word that resembles an existing title (e.g., 'Theindianexpress' for 'The Indian Express').",
    "Titles must avoid prefixes or suffixes that cause them to resemble existing titles closely.",
    "New submissions will be rejected if they are too similar to titles currently under verification.",
    "Titles must comply with all linguistic and cultural sensitivities.",
  ];

  return (
    <div>
      <h2>Title Submission Guidelines</h2>
      <ul>
        {guidelines.map((guideline, index) => (
          <li key={index}>{guideline}</li>
        ))}
      </ul>
    </div>
  );
};

export default Guidelines;
